
import Index from "views/Index.js";

import Login from "views/examples/Login.js";
import ResellerLogin from "views/examples/ResellerLogin.js";

//
import GameList from "views/components/game/GameList.js";
import UserList from "views/components/UserList";
import OrderList from "views/components/OrderList";
import DepositList from "views/components/deposit/DepositList";
import UnitTransactionList from "views/components/UnitTransactionList";
import PaymentProviderList from "views/components/PaymentProviderList";
import PaymentAccountList from "views/components/PaymentAccountList";
import Announcement from "views/components/announcement/Announcement";
import AppGuide from "views/components/appguide/AppGuide";
import BannerImage from "views/components/BannerImage";

import ManualOrder from "views/components/ManualOrder";
import Expense from "views/components/Expense";
import PaymentReceived from "views/components/PaymentReceived";
import Preorder from "views/components/Preorder";
import Reseller from "views/components/Reseller";
import OtherReseller from "views/components/OtherReseller";

import ResellerReport from "views/components/reseller/ResellerReport";

import PointTransactionList from "views/components/PointTransactionList";
import SpinRecordList from "views/components/SpinRecordList";

import PointPercent from "views/components/points/PointPercent";

import AdsPopup from "views/components/ads/AdsPopup";



var main_routes = [
  {
    path: "/index",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },
  {
    path: "/game-lists",
    name: "Games",
    icon: "ni ni-controller text-orange",
    component: GameList,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },
  {
    path: "/users",
    name: "Users",
    icon: "ni ni-circle-08 text-info",
    component: UserList,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },
  {
    path: "/manual-order",
    name: "POS",
    icon: "ni ni-cart text-red",
    component: ManualOrder,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },
  {
    path: "/expense",
    name: "Expense",
    icon: "ni ni-money-coins text-red",
    component: Expense,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },

  {
    path: "/orders",
    name: "Orders",
    icon: "ni ni-send text-red",
    component: OrderList,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN", "CS"],
  },
  {
    path: "/preorder",
    name: "Pre-Order",
    icon: "ni ni-money-coins text-red",
    component: Preorder,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },
  {
    path: "/ml-reseller",
    name: "ML Reseller",
    icon: "ni ni-money-coins text-red",
    component: Reseller,
    layout: "/admin",
    type: "main",
    roles: ["RESELLER"],
  },
  {
    path: "/other-reseller",
    name: "PUBG Reseller",
    icon: "ni ni-money-coins text-red",
    component: OtherReseller,
    layout: "/admin",
    type: "main",
    roles: ["RESELLER"],
  },
  {
    path: "/reseller-overview",
    name: "Overview",
    icon: "ni ni-money-coins text-red",
    component: ResellerReport,
    layout: "/admin",
    type: "main",
    roles: ["RESELLER"],
  },
  // {
  //   path: "/reseller-overview",
  //   name: "Deposit & Withdraw",
  //   icon: "ni ni-money-coins text-red",
  //   component: ResellerReport,
  //   layout: "/admin",
  //   type: "main",
  //   roles: ["RESELLER"],
  // },
  // {
  //   path: "/tables",
  //   name: "Direct Topup",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: Tables,
  //   layout: "/admin",
  //   type: "main",
  // },
  {
    path: "/deposits",
    name: "Deposits",
    icon: "ni ni-curved-next text-red",
    component: DepositList,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN", "CS"],
    noti: 2,
  },
  {
    path: "/uni-transactions",
    name: "Transactions",
    icon: "ni ni-collection text-blue",
    component: UnitTransactionList,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN", "CS","RESELLER"],
  },
  {
    path: "/point-transactions",
    name: "Point Transactions",
    icon: "ni ni-bullet-list-67 text-primary",
    component: PointTransactionList,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },
  {
    path: "/spin-records",
    name: "Spin Records",
    icon: "ni ni-bullet-list-67 text-primary",
    component: SpinRecordList,
    layout: "/admin",
    type: "main",
    roles: ["ADMIN"],
  },

  // {
  //   path: "/promotion-sms",
  //   name: "Send SMS (or) Email",
  //   icon: "ni ni-collection text-blue",
  //   component: SendPromotionSMS,
  //   layout: "/admin",
  //   type: "main",
  //   roles: ["ADMIN"],
  // },
];

let payment_routes = [
  {
    path: "/payment-transactions",
    name: "Payment Received",
    icon: "ni ni-curved-next text-red",
    component: PaymentReceived,
    layout: "/admin",
    type: "payment",
    roles: ["ADMIN"],
  },
  {
    path: "/payment-providers",
    name: "Payment Provider",
    icon: "ni ni-bullet-list-67 text-red",
    component: PaymentProviderList,
    layout: "/admin",
    type: "payment",
    roles: ["ADMIN"],
  },
  {
    path: "/payment-accounts",
    name: "Payment Account",
    icon: "ni ni-bullet-list-67 text-red",
    component: PaymentAccountList,
    layout: "/admin",
    type: "payment",
    roles: ["ADMIN"],
  },
];

let cms_routes = [
  {
    path: "/messages",
    name: "Messages",
    icon: "ni ni-bullet-list-67 text-red",
    component: Announcement,
    layout: "/admin",
    type: "cms",
    roles: ["ADMIN"],
  },
  {
    path: "/app-guide",
    name: "App Guides",
    icon: "ni ni-bullet-list-67 text-red",
    component: AppGuide,
    layout: "/admin",
    type: "cms",
    roles: ["ADMIN"],
  },
  // {
  //   path: "/tables",
  //   name: "Post Categories",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: Tables,
  //   layout: "/admin",
  //   type: "cms",
  //   roles: ["ADMIN"],
  // },
  // {
  //   path: "/post",
  //   name: "Posts",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: Post,
  //   layout: "/admin",
  //   type: "cms",
  //   roles: ["ADMIN"],
  // },
  {
    path: "/banner-image",
    name: "Banner Image",
    icon: "ni ni-bullet-list-67 text-red",
    component: BannerImage,
    layout: "/admin",
    type: "cms",
    roles: ["ADMIN"],
  },
  {

    path: "/point-percent",
    name: "Point Percent",
    icon: "ni ni-diamond text-green",
    component: PointPercent,
     layout: "/admin",
    type: "cms",
    roles: ["ADMIN"],
  },
  {
    path: "/popup-ads",
    name: "Ads Popup",
    icon: "ni ni-bullet-list-67 text-red",
    component: AdsPopup,
    layout: "/admin",
    type: "cms",
    roles: ["ADMIN"],
  },
  // {
  //   path: "/regions",
  //   name: "Regions",
  //   icon: "ni ni-bullet-list-67 text-red",
  //   component: Regions,
  //   layout: "/admin",
  //   type: "cms",
  //   roles: ["ADMIN"],
  // },
];

let other_routes = [
  {
    path: "/admin/login",
    name: "Login",
    icon: "ni ni-tv-2 text-primary",
    component: Login,
    layout: "/auth",
    type: "login",
    roles: [null,'ADMIN'],
  },
  {
    path: "/reseller/login",
    name: "Login",
    icon: "ni ni-tv-2 text-primary",
    component: ResellerLogin,
    layout: "/auth",
    type: "login",
    roles: [null,'RESELLER'],
  },
];

let routes = [
  ...main_routes,
  ...cms_routes,
  ...other_routes,
  ...payment_routes,
];

let user_role = sessionStorage.getItem("user_role");
// console.log("user_role", user_role);

routes = routes.filter((route) => route.roles.includes(user_role));

export default routes;
